export const CSRF_HEADER = 'x-xsrf-token';
export const FAQS_API_PREFIX = '/faq-api';
export const CENTRAL_API_PREFIX = '/api';
export const CONTENTFUL_API_PREFIX = `${CENTRAL_API_PREFIX}/contentful`;
